import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getVariableManagements: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		//console.log('searchParams', searchParams);

		if (searchParams.varId !== undefined || searchParams.strtDt !== undefined) {
			queryStr = objectToQuerystring({
				varId: searchParams.varId,
				varVal: searchParams.varVal,
				useYn: searchParams.useYn,
				strtDt: searchParams.strtDt,
				currentPage,
				pageUnit
			});
		}
		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/comm/qmsbase/variable/v1/variables` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postVariableManagement: param => {
		//console.log('debug', param);
		return client
			.post(`${BASE_URL}/comm/qmsbase/variable/v1/status/${param.status}`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
